import r from "react";
import { a as y, b as S } from "./index-wif4gfZf.js";
import { u as M } from "./index-DLcqcWxM.js";
import { j as d } from "./utils-BdNIfrGQ.js";
function h(s) {
  const a = s + "CollectionProvider", [A, E] = y(a), [N, m] = A(
    a,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), p = (c) => {
    const { scope: e, children: l } = c, o = r.useRef(null), t = r.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d.jsx(N, { scope: e, itemMap: t, collectionRef: o, children: l });
  };
  p.displayName = a;
  const f = s + "CollectionSlot", _ = S(f), C = r.forwardRef(
    (c, e) => {
      const { scope: l, children: o } = c, t = m(f, l), n = M(e, t.collectionRef);
      return /* @__PURE__ */ d.jsx(_, { ref: n, children: o });
    }
  );
  C.displayName = f;
  const u = s + "CollectionItemSlot", R = "data-radix-collection-item", T = S(u), x = r.forwardRef(
    (c, e) => {
      const { scope: l, children: o, ...t } = c, n = r.useRef(null), I = M(e, n), i = m(u, l);
      return r.useEffect(() => (i.itemMap.set(n, { ref: n, ...t }), () => {
        i.itemMap.delete(n);
      })), /* @__PURE__ */ d.jsx(T, { [R]: "", ref: I, children: o });
    }
  );
  x.displayName = u;
  function O(c) {
    const e = m(s + "CollectionConsumer", c);
    return r.useCallback(() => {
      const o = e.collectionRef.current;
      if (!o) return [];
      const t = Array.from(o.querySelectorAll(`[${R}]`));
      return Array.from(e.itemMap.values()).sort(
        (i, v) => t.indexOf(i.ref.current) - t.indexOf(v.ref.current)
      );
    }, [e.collectionRef, e.itemMap]);
  }
  return [
    { Provider: p, Slot: C, ItemSlot: x },
    O,
    E
  ];
}
export {
  h as c
};
